<template>
	<div class="providers">
		<div class="providers__search">
			<input class="text-field__input" v-model="search" placeholder="Введите имя провайдера">
		</div>
		<div class="providers__groups no-scrollbar" data-scroll-lock-scrollable>
			<div class="providers__groups-col" v-for="(groupCol, idx) in [groups, groups2]">
				<div class="providers__group" v-if="idx === 0">
					<div class="providers__group-key"><div class="providers__group-key-val"></div></div>
					<div class="providers__items">
						<div class="providers__item" @click="handlerSetAll">
							<svg class="providers__item-icon"><use href="#svg-icon-all-dots"></use></svg>
							<span class="providers__item-text">Все провайдеры</span>
						</div>
					</div>
				</div>

				<div class="providers__group" v-for="group in groupCol">
					<div class="providers__group-key">
						<div class="providers__group-key-val">{{group.key}}</div>
					</div>
					<div class="providers__items">
						<div class="providers__item"
							 v-for="provider in group.items"
							 @click="setActive(provider)"
							 :key="provider.provider_id"
							 :class="{active: active && active === provider.provider_id}"
						>
							<img class="providers__item-icon" :src="provider.icon" alt="">
							<span class="providers__item-text">{{provider.provider_name}}</span>
							<span v-if="provider.vpn_required" class="providers__item-vpn">VPN</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {

	emits: [
		'set-active',
		'set-all'
	],

	props: {
		providers: {
			type: Array,
			default: null
		},

		active: {
			type: [String, Number],
			default: null
		}
	},

	data() {
		return {
			items: null,
			search: null,
			groups: [],
			groups2: []
		}
	},

	watch: {
		providers() {
			this.items = this.providers;
			this.sortItems();
		},

		search() {
			if (this.search) {
				this.items = this.providers.filter(item => item.provider_name.toLowerCase().includes(this.search.toLowerCase()))
			} else {
				this.items = this.providers;
			}
			this.sortItems();
		}
	},


	mounted() {
		this.items = this.providers;
		this.sortItems();
	},

	methods: {

		setActive(item) {
			this.$emit('set-active', item.provider_id)
		},

		sortItems() {
			let groupsObj = {};
			let count = 0;
			this.groups = [];
			this.groups2 = [];

			this.items.forEach(item => {
				let key = item.provider_name.toLowerCase()[0];
				if (groupsObj[key]) {
					groupsObj[key].items.push(item);
				} else {
					groupsObj[key] = {
						key: key,
						items: [item]
					}
				}
			})

			Object.values(groupsObj).forEach(item => {
				 if (this.items.length / 2 >= count) {
					 count = count + item.items.length;
					 this.groups.push(item)
				 } else {
					 this.groups2.push(item)
				 }
			})
		},

		handlerSetAll() {
			this.search = null;
			this.$emit('set-all');
		}
	},

	unmounted() {
		this.search = null;
	}
}

</script>